export default __webpack_public_path__ + "static/media/mariya-georgieva.0817f394.jpg";